module.exports = "<main>\n  <subhead [handle]=\"handle\" [link]=\"link\"></subhead>  \n  <div class=\"loading\" *ngIf=\"!vimeoList\">\n    <h3>Loading videos...</h3>\n  </div>\n  <div>\n    <vimeo-player *ngFor='let video of vimeoList' [video]=\"video\"></vimeo-player>\n    <h2><a href=\"http://www.vimeo.com/markdgold\" target=\"_blank\">View more on Vimeo</a></h2>\n  </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/vimeo/vimeo.component.html
// module id = ../../../../../src/app/vimeo/vimeo.component.html
// module chunks = main